export const sootingDegreeCalculationMethods = {
  sootIndex: "sootIndex",
  burnHourCount: "burnHourCount",
};
export type SootingDegreeCalculationMethod =
  (typeof sootingDegreeCalculationMethods)[keyof typeof sootingDegreeCalculationMethods];
